import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { lastValueFrom } from "rxjs";
import { TranslateService } from '@ngx-translate/core';
import { OxomiSupplier } from "../Model/Dto/Oxomi/OxomiSupplier";


@Injectable()
export class OxomiSortimentService {

  private _oxomiUpdateAvailable: boolean = false;

  public get oxomiUpdateAvailable(): boolean {
    return this._oxomiUpdateAvailable;
  }
  public set oxomiUpdateAvailable(value: boolean) {
    this._oxomiUpdateAvailable = value;
  }

  constructor(private http: HttpClient, public translate: TranslateService) {}

  getUpdateForSupplierAvailable(customerId: string) {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("customerId", customerId)
    } 
    lastValueFrom(this.http.get<boolean>("api/OxomiSortiment/GetUpdateForSupplierAvailable", options)).then((value) => {this.oxomiUpdateAvailable = value});    
  }

  getOxomiSupplier(customerId: string): Promise<OxomiSupplier[]> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("customerId", customerId)
    }
    return lastValueFrom(this.http.get<OxomiSupplier[]>("api/OxomiSortiment/GetAllSupplier", options));
  }

  createSupplier(newSupplier: OxomiSupplier, customerId: string): Promise<OxomiSupplier> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("customerId", customerId)
    }
    
    var result = this.http.post<OxomiSupplier>("api/OxomiSortiment/CreateSupplier", newSupplier, options);
    return lastValueFrom(result);
  }

  deleteSupplier(supplierToDelete: OxomiSupplier, customerId: string): Promise<boolean> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("customerId", customerId)
    }
    
    var result = this.http.post<boolean>("api/OxomiSortiment/DeleteSupplier", supplierToDelete, options);
    return lastValueFrom(result);
  }

  updateSupplier(supplierToUpdate: OxomiSupplier, customerId: string): Promise<boolean> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("customerId", customerId)
    }
    
    var result = this.http.post<boolean>("api/OxomiSortiment/UpdateSupplier", supplierToUpdate, options);
    return lastValueFrom(result);
  }

  checkForDataUpdate(supplierNumber: string, customerId: string): Promise<boolean> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("customerId", customerId).append("supplierNumber", supplierNumber),
      
    }    
    var result = this.http.get<boolean>("api/OxomiSortiment/UpdateCheck", options);
    return lastValueFrom(result);
  }

  updateData(supplierNumber: string, supplierName: string, customerId: string): Promise<boolean> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("customerId", customerId).append("supplierNumber", supplierNumber).append("supplierName", supplierName),
      
    }    
    var result = this.http.get<boolean>("api/OxomiSortiment/StartUpdateJob", options);
    return lastValueFrom(result);
  }
}